const WINDOWS = [1, 3, 7, 14, 30, 90]

export default function AttributionWindowControl({ value, onChange }) {
  return <label className="flex flex-col gap-1 text-xs text-muted-foreground">
    Attribution window
    <select className="h-9 rounded-md border border-input bg-background px-3 text-sm" value={value} onChange={event => onChange(event.target.value === 'all' ? 'all' : Number(event.target.value))}>
      <option value="all">All eligible credit</option>
      {WINDOWS.map(days => <option key={days} value={days}>{days} {days === 1 ? 'day' : 'days'} of touch</option>)}
    </select>
  </label>
}

/**
 * Lookback is all time for every brand (lib/attributionLookback), so the one
 * window left to explain is the attribution window, which relabels the model's
 * OUTPUTS rather than filtering its inputs. The worked example shows it on a
 * real-shaped sale rather than describing it in prose.
 */
const EXAMPLE = [
  { setting: 'All eligible credit', result: 'Meta $45, Google $45' },
  { setting: 'Credit within 7 days', result: 'Google $45, Outside window $45' },
]

export function AttributionWindowExplanation() {
  return <details className="rounded-md border p-3 text-sm">
    <summary className="cursor-pointer font-medium">How attribution windows and reporting dates work</summary>
    <div className="mt-3 space-y-3 text-muted-foreground">
      <p>Every visit before a payment counts, however long ago: the lookback is all time. <strong className="text-foreground">Attribution window</strong> filters nothing — credit is assigned first, and a share whose touch is older than the window is filed under Outside window at its original size. Shares are never redistributed.</p>
      <p>For a $90 sale with Meta 10 days before payment and Google 2 days before, on Linear:</p>
      <div className="overflow-x-auto rounded-md border">
        <table className="w-full text-sm">
          <caption className="sr-only">How the attribution window changes the same $90 sale</caption>
          <thead className="bg-muted/50"><tr>
            <th scope="col" className="p-2 text-left font-medium">Setting</th>
            <th scope="col" className="p-2 text-left font-medium">Credit</th>
          </tr></thead>
          <tbody>{EXAMPLE.map(row => <tr key={row.setting} className="border-t">
            <th scope="row" className="p-2 text-left font-normal whitespace-nowrap">{row.setting}</th>
            <td className="p-2 tabular-nums">{row.result}</td>
          </tr>)}</tbody>
        </table>
      </div>
      <ul className="list-disc space-y-1 pl-5">
        <li>Outside-window credit is excluded from CAC and ROAS, so a tighter attribution window shrinks credited orders while spend stays fixed: CAC rises, ROAS falls.</li>
        <li>The real channels then sum to less than actual sales, with the remainder in Outside window.</li>
        <li>A new sale on a Sales Team or Reddit price book with no matching visit gets a closing touch added at payment time. It is zero days old, so it never falls outside any attribution window.</li>
      </ul>
      <p>Event date groups credit with the sale. Click date groups it with the visit, including payments received later. Actual paid orders and revenue always refer to payments in the selected dates. Credit without a dated touch has no click date and is excluded from that view.</p>
      <p>All eligible credit is not customer lifetime value. Windows use elapsed 24-hour days, including the exact boundary. Reporting dates use Eastern time.</p>
    </div>
  </details>
}
